import React from 'react';
import { Checkbox, Slider, Button, Divider } from 'antd';

import { formatPrice } from '../../../data/helpers';
import {
  FilterPanelWrapper,
  FilterSection,
  FilterHeading,
  PriceLabels,
  ClearButton,
} from '../styles';

const PUBLICATION_TYPES = ['Novela', 'Cuentos', 'Ensayo', 'Memorias'];
const CONDITIONS = ['Nuevo', 'Como nuevo', 'Bueno', 'Aceptable'];
const COVER_TYPES = ['Tapa dura', 'Tapa blanda'];
const LANGUAGES = ['Español', 'Inglés'];

const PRICE_MIN = 0;
const PRICE_MAX = 25000;
const PRICE_STEP = 500;

export default function FilterPanel({
  publicationType,
  onPublicationTypeChange,
  condition,
  onConditionChange,
  coverType,
  onCoverTypeChange,
  language,
  onLanguageChange,
  priceRange,
  onPriceRangeChange,
  onClearFilters,
}) {
  return (
    <FilterPanelWrapper>
      <FilterSection>
        <FilterHeading>Tipo de producto</FilterHeading>
        <Checkbox.Group
          options={PUBLICATION_TYPES}
          value={publicationType}
          onChange={onPublicationTypeChange}
          style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
        />
      </FilterSection>

      <Divider style={{ margin: '0 0 24px' }} />

      <FilterSection>
        <FilterHeading>Condición</FilterHeading>
        <Checkbox.Group
          options={CONDITIONS}
          value={condition}
          onChange={onConditionChange}
          style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
        />
      </FilterSection>

      <Divider style={{ margin: '0 0 24px' }} />

      <FilterSection>
        <FilterHeading>Encuadernación</FilterHeading>
        <Checkbox.Group
          options={COVER_TYPES}
          value={coverType}
          onChange={onCoverTypeChange}
          style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
        />
      </FilterSection>

      <Divider style={{ margin: '0 0 24px' }} />

      <FilterSection>
        <FilterHeading>Rango de precio</FilterHeading>
        <Slider
          range
          min={PRICE_MIN}
          max={PRICE_MAX}
          step={PRICE_STEP}
          value={priceRange}
          onChange={onPriceRangeChange}
        />
        <PriceLabels>
          <span>{formatPrice(priceRange[0])}</span>
          <span>{formatPrice(priceRange[1])}</span>
        </PriceLabels>
      </FilterSection>

      <Divider style={{ margin: '0 0 24px' }} />

      <FilterSection>
        <FilterHeading>Idioma</FilterHeading>
        <Checkbox.Group
          options={LANGUAGES}
          value={language}
          onChange={onLanguageChange}
          style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
        />
      </FilterSection>

      <ClearButton>
        <Button block onClick={onClearFilters}>
          Limpiar filtros
        </Button>
      </ClearButton>
    </FilterPanelWrapper>
  );
}
